<script>
  export let fixtures = [];
</script>

<div class="bracket-container">
  {#if !fixtures || fixtures.length === 0}
    <div class="empty-bracket">
      <span style="font-size: 24px;">🏆</span>
      <p style="margin: 4px 0 0; color: #94a3b8; font-size: 13px;">Playoff brackets will generate automatically after group stage matches.</p>
    </div>
  {:else}
    <div class="bracket-grid">
      {#each fixtures as f, i_each (i_each)}
        <div class="fixture-card" class:final-card={f.id === 'FINAL'}>
          <div class="card-header">
            <span class="f-title">{f.title}</span>
            <span class="f-badge" class:badge-final={f.id === 'FINAL'}>{f.badge}</span>
          </div>
          <div class="teams-container">
            <div class="team-row">
              <span class="t-name">{f.teamA}</span>
            </div>
            <div class="vs-divider">VS</div>
            <div class="team-row">
              <span class="t-name">{f.teamB}</span>
            </div>
          </div>
          <div class="card-footer">
            <span>ℹ️ {f.description}</span>
          </div>
        </div>
      {/each}
    </div>
  {/if}
</div>

<style>
  .bracket-container {
    padding: 8px 0;
  }
  .empty-bracket {
    text-align: center;
    padding: 24px 16px;
    background: rgba(15, 23, 42, 0.6);
    border: 1px dashed rgba(255, 255, 255, 0.15);
    border-radius: 12px;
  }
  .bracket-grid {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  .fixture-card {
    background: rgba(15, 23, 42, 0.85);
    backdrop-filter: blur(12px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    padding: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    transition: transform 0.15s ease, border-color 0.15s ease;
  }
  .fixture-card:hover {
    border-color: rgba(110, 229, 145, 0.3);
  }
  .final-card {
    background: linear-gradient(135deg, rgba(30, 27, 75, 0.9) 0%, rgba(49, 16, 66, 0.9) 100%);
    border: 1px solid rgba(251, 191, 36, 0.5);
    box-shadow: 0 0 15px rgba(251, 191, 36, 0.2);
  }
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  }
  .f-title {
    font-weight: 900;
    font-size: 13px;
    color: #fff;
    letter-spacing: 0.5px;
  }
  .f-badge {
    font-size: 10px;
    font-weight: 800;
    padding: 2px 6px;
    border-radius: 4px;
    background: rgba(110, 229, 145, 0.15);
    color: #6ee591;
    text-transform: uppercase;
  }
  .badge-final {
    background: linear-gradient(135deg, #fbbf24, #f59e0b);
    color: #451a03;
  }
  .teams-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: rgba(2, 6, 23, 0.6);
    border-radius: 8px;
    padding: 8px 12px;
    margin: 4px 0 8px;
  }
  .team-row {
    flex: 1;
    font-weight: 800;
    font-size: 13px;
    color: #e2e8f0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .vs-divider {
    font-size: 10px;
    font-weight: 900;
    color: #94a3b8;
    padding: 0 8px;
  }
  .card-footer {
    font-size: 11px;
    color: #94a3b8;
    font-weight: 600;
  }
</style>
